/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectItemTaskCommand } from '../../models/create-project-item-task-command';
import { CreateProjectItemTaskCommandResult } from '../../models/create-project-item-task-command-result';

export interface ApiProjectItemsTasksCreateProjectItemTaskPost$Params {
      body?: CreateProjectItemTaskCommand
}

export function apiProjectItemsTasksCreateProjectItemTaskPost(http: HttpClient, rootUrl: string, params?: ApiProjectItemsTasksCreateProjectItemTaskPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectItemTaskCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemsTasksCreateProjectItemTaskPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectItemTaskCommandResult>;
    })
  );
}

apiProjectItemsTasksCreateProjectItemTaskPost.PATH = '/api/ProjectItemsTasks/CreateProjectItemTask';
